// modules
import { useMemo } from "react";

// hooks
import { useAppDispatch, useAppSelector } from "app/hooks/hooks";

// redux
import { delinkMember, getCardEnquiryDetailsSelector, getMemberEnquiryDetailsSelector, resetEnquiryDetails } from "redux/userList/userSlice";

// component
import CountDownModal from "components/molecules/ModalContainer/CountDownModalContainer";

// constants
import { getPayloadData } from "utils/getDelinkPayload";
import { CapitaStarDelink as Constants } from "constants/global";

type CapitaStarDelinkUtilTypes = {
	capitaStarNumber: string;
	submitUtilHandler: (cardNumber?: string, userId?: string, resetForm?: () => void) => Promise<void>;
};

type DelinkPayload = {
	account: string;
	cr_card_number?: string;
	memberid?: string;
};

export function useCapitaStarDelinkUtil(): CapitaStarDelinkUtilTypes {
	const dispatch = useAppDispatch();
	const cardEnquiryDetails = useAppSelector(getCardEnquiryDetailsSelector);
	const memberEnquiryDetails = useAppSelector(getMemberEnquiryDetailsSelector);

	const capitaStarNumber = useMemo(() => {
		if (cardEnquiryDetails) {
			return cardEnquiryDetails?.data?.capitastar_no;
		}
		if (memberEnquiryDetails) {
			return memberEnquiryDetails?.data?.capitastar_no;
		}
		return "";
	}, [cardEnquiryDetails, memberEnquiryDetails]);

	const submitUtilHandler = async (cardNumber?: string, userId?: string, resetForm?: () => void) => {
		try {
			const payload: DelinkPayload | undefined = getPayloadData(cardNumber, userId, Constants.ACCOUNT_TYPE);
			if (payload) {
				const { errors, message } = await dispatch(delinkMember(payload)).unwrap();

				if (!errors?.length && message) {
					CountDownModal({
						timer: 3,
						title: message,
						closable: true,
						onTimeComplete: () => {
							dispatch(resetEnquiryDetails());
							resetForm?.();
						}
					});
				}
			}
		} catch (error) {
			const err = error as any;
			if (err?.response?.data?.errors && err?.response?.data?.errors?.length > 0) {
				CountDownModal({
					timer: 3,
					errorIcon: true,
					title: err?.response?.data?.errors?.[0]?.message
				});
			}
		}
	};

	return { capitaStarNumber, submitUtilHandler };
}
